import { gql } from "@urql/core";

export const PURCHASE_ORDER_QUERY = gql`
  query PurchaseOrders(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    purchaseOrders(query:{filter: $filter, sorting: $sorting, paging: $paging}) {
      nodes {
        id
        orderNo
        templateId
        teamId
        dateCreated
        orderDeadline
        expectedDeliveryDate
        actualDeliveryDate
        createdBy
        updatedBy
        orderedBy
        vendor {
          vendorId
          companyName
          contactPerson
          email
          phone
          address
          tin
        }
        purchaseRequestRef {
          requestId
          requestNo
          linkedAt
          linkedBy
        }
        items {
          id
          name
          description
          quantity
          unit
          unitPrice
          totalPrice
          specifications
          expectedDeliveryDate
          sourceRequestItemId
          planRef {
            planId
            itemId
          }
          tags
          deliveredQuantity
          actualDeliveryDate
        }
        subtotalAmount
        taxAmount
        shippingAmount
        discountAmount
        totalAmount
        currency
        exchangeRate {
          fromCurrency
          toCurrency
          rate
          rateDate
          source
        }
        paymentTerms
        shippingInfo {
          method
          carrierType
          carrierName
          trackingNumber
          shippingAddress
          shippingCost
          specialInstructions
        }
        status
        approvals {
          order
          roleSlug
          stepName
          approvedBy
          approvedOn
          remarks
          stepStatus
        }
        budgetValidation {
        validatedBy
        validatedAt
        remarks
        totalAmount
        }
        attachments {
          fileId
          originalName
          mimeType
          size
          category
        }
        notes
        termsAndConditions
        tags
        approvalType
        steps {
          order
          roleSlug
          stepName
        }
        externalWorkflow
        approvalData
        flowCaseId
        flowCaseNumber
        submittedBy
        createdAt
        updatedAt
        vendorAcknowledgedAt
        vendorAcknowledgmentRef
      }

    }
  }
`;

export const PURCHASE_ORDER_BY_ID_QUERY = gql`
  query PurchaseOrderById($id: String!) {
    purchaseOrder(id: $id) {
      id
      orderNo
      templateId
      teamId
      dateCreated
      orderDeadline
      expectedDeliveryDate
      actualDeliveryDate
      createdBy
      updatedBy
      orderedBy
      vendor {
        vendorId
        companyName
        contactPerson
        email
        phone
        address
        tin
      }
      purchaseRequestRef {
        requestId
        requestNo
        linkedAt
        linkedBy
      }
      items {
        id
        name
        description
        quantity
        unit
        unitPrice
        totalPrice
        specifications
        expectedDeliveryDate
        sourceRequestItemId
        planRef {
          planId
          itemId
        }
        tags
        deliveredQuantity
        actualDeliveryDate
      }
      subtotalAmount
      taxAmount
      shippingAmount
      discountAmount
      totalAmount
      currency
      exchangeRate {
        fromCurrency
        toCurrency
        rate
        rateDate
        source
      }
      paymentTerms
      shippingInfo {
        method
        carrierType
        carrierName
        trackingNumber
        shippingAddress
        shippingCost
        specialInstructions
      }
      status
      approvals {
        order
        roleSlug
        stepName
        approvedBy
        approvedOn
        remarks
        stepStatus
      }
      budgetValidation {
        validatedBy
        validatedAt
        remarks
        totalAmount
      }
      attachments {
        fileId
        originalName
        mimeType
        size
        category
      }
      notes
      termsAndConditions
      tags
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
      invoiceId
      createdAt
      updatedAt
      vendorAcknowledgedAt
      vendorAcknowledgmentRef
    }
  }
`;

export const CREATE_PURCHASE_ORDER_MUTATION = gql`
  mutation CreatePurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      id
      orderNo
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const CREATE_PURCHASE_ORDER_FROM_REQUEST_MUTATION = gql`
  mutation CreatePurchaseOrderFromRequest($input: CreatePurchaseOrderFromRequestInput!) {
    createPurchaseOrderFromRequest(input: $input) {
      id
      orderNo
      purchaseRequestRef {
        requestId
        requestNo
      }
    }
  }
`;

export const UPDATE_PURCHASE_ORDER_MUTATION = gql`
  mutation UpdatePurchaseOrder($id: String!, $input: UpdatePurchaseOrderInput!) {
    updatePurchaseOrder(id: $id, input: $input) {
      id
      orderNo
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const DELETE_PURCHASE_ORDER_MUTATION = gql`
  mutation DeletePurchaseOrder($id: String!) {
    deletePurchaseOrder(id: $id) {
      id
    }
  }
`;

export const SUBMIT_PURCHASE_ORDER_MUTATION = gql`
  mutation SubmitPurchaseOrder($input: SubmitPurchaseOrderInput!) {
    submitPurchaseOrder(input: $input) {
      id
      status
      approvalType
      steps {
        order
        roleSlug
        stepName
      }
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      submittedBy
    }
  }
`;

export const LINK_PURCHASE_REQUEST_TO_ORDER_MUTATION = gql`
  mutation LinkPurchaseRequestToOrder($input: LinkPurchaseRequestInput!) {
    linkPurchaseRequestToOrder(input: $input) {
      id
      purchaseRequestRef {
        requestId
        requestNo
      }
    }
  }
`;

export const APPROVE_PURCHASE_ORDER_STEP_MUTATION = gql`
  mutation ApprovePurchaseOrderStep($input: OrderApprovalInput!) {
    approvePurchaseOrderStep(input: $input) {
      id
      approvals {
        order
        stepStatus
      }
    }
  }
`;

export const REJECT_PURCHASE_ORDER_STEP_MUTATION = gql`
  mutation RejectPurchaseOrderStep($input: OrderApprovalInput!) {
    rejectPurchaseOrderStep(input: $input) {
      id
      approvals {
        order
        stepStatus
      }
    }
  }
`;

export const VALIDATE_PURCHASE_ORDER_BUDGET_MUTATION = gql`
  mutation ValidatePurchaseOrderBudget($input: ValidatePurchaseOrderBudgetInput!) {
    validatePurchaseOrderBudget(input: $input) {
      id
      budgetValidation {
        isValid
        message
      }
    }
  }
`;

export const UPDATE_PURCHASE_ORDER_DELIVERY_MUTATION = gql`
  mutation UpdatePurchaseOrderDelivery($input: UpdateDeliveryInput!) {
    updatePurchaseOrderDelivery(input: $input) {
      id
      items {
        id
        deliveredQuantity
        actualDeliveryDate
      }
    }
  }
`;

export const VENDOR_ACKNOWLEDGE_PURCHASE_ORDER_MUTATION = gql`
  mutation VendorAcknowledgePurchaseOrder($input: VendorAcknowledgmentInput!) {
    vendorAcknowledgePurchaseOrder(input: $input) {
      id
      vendorAcknowledgedAt
      vendorAcknowledgmentRef
    }
  }
`;

export const CANCEL_PURCHASE_ORDER_MUTATION = gql`
  mutation CancelPurchaseOrder($orderId: String!) {
    cancelPurchaseOrder(orderId: $orderId) {
      id
      status
    }
  }
`;

export const COMPLETE_PURCHASE_ORDER_MUTATION = gql`
  mutation CompletePurchaseOrder($orderId: String!) {
    completePurchaseOrder(orderId: $orderId) {
      id
      status
    }
  }
`;

export const ATTACH_FILES_TO_PURCHASE_ORDER_MUTATION = gql`
  mutation AttachFilesToPurchaseOrder($input: AttachFilesToPurchaseOrderInput!) {
    attachFilesToPurchaseOrder(input: $input) {
      id
      attachments {
        fileId
        originalName
        mimeType
        size
        category
      }
    }
  }
`;

export const REMOVE_FILE_FROM_PURCHASE_ORDER_MUTATION = gql`
  mutation RemoveFileFromPurchaseOrder($input: RemoveFileFromPurchaseOrderInput!) {
    removeFileFromPurchaseOrder(input: $input) {
      id
      attachments {
        fileId
      }
    }
  }
`;

export const CREATE_INVOICE_FROM_PO_MUTATION = gql`
  mutation CreateInvoiceFromPO($poId: String!, $supplierPortalInvoice: JSON!) {
    createInvoiceFromPO(poId: $poId, supplierPortalInvoice: $supplierPortalInvoice) {
      id
      invoiceNumber
      supplierName
      totalAmount
      status
      matchStatus
      approvalStatus
      paymentStatus
      fileId
      createdAt
    }
  }
`;

export const GET_INVOICES_BY_PO_NUMBER_QUERY = gql`
  query GetInvoicesByPONumber($poNumber: String!) {
    getInvoicesByPONumber(poNumber: $poNumber)
  }
`;